export const cleanUpTimer = (current?: ReturnType<typeof setTimeout>) => current && clearTimeout(current);
